import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 pt-0" }
const _hoisted_2 = { class: "overflow-auto" }
const _hoisted_3 = { class: "table table-striped border-light align-middle text-left position-relative" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  colspan: "5",
  class: "text-center text-muted py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.reattach_counterparty'),
    "dialog-class": "modal-lg",
    modelValue: _ctx.isVisible,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisible = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        class: "h-100"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("table", _hoisted_3, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
                    _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.holderName')), 1),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.method')), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRequisites, (req, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: ""
                    }, [
                      _createElementVNode("td", null, _toDisplayString(req.requisites), 1),
                      _createElementVNode("td", null, _toDisplayString(req.currency), 1),
                      _createElementVNode("td", null, _toDisplayString(req.holderName), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + req.method)), 1),
                      _createElementVNode("td", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.selectRequisite(req.id)),
                          class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('labels.select')), 9, _hoisted_9)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.availableRequisites.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.no_available_requisites')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}